module.exports = __webpack_public_path__ + "static/media/AeroFarm.eedf16dd.svg";